import { type FC, type PropsWithChildren, type RefObject } from 'react';

import { cls } from '@/utils/cls';

export type FullPageContentProps = PropsWithChildren<{
  className?: string;
  scrollable?: boolean;
  testId?: string;
  containerRef?: RefObject<HTMLDivElement>;
}>;

export const FullPageContent: FC<FullPageContentProps> = ({
  children,
  className,
  testId,
  containerRef,
  scrollable = false,
}) => {
  return (
    <div
      className={cls(
        'size-full',
        className,
        scrollable ? 'overflow-y-auto' : 'overflow-y-hidden',
      )}
      data-testid={testId}
      ref={containerRef}
    >
      {children}
    </div>
  );
};
